<script setup lang="ts">
import { ref } from 'vue'
import { VSwitch } from '@/modules/shared/components'
import { useTaskListStore } from '../stores/tasking-store'

const props = defineProps<{
  taskListId: number
}>()

const store = useTaskListStore()
const isLoading = ref(false)

const toggleTaskListVisibility = async () => {
  if (isLoading.value) return

  isLoading.value = true
  if (store.taskList?.is_visible) {
    await store.hideTaskList(props.taskListId)
  } else {
    await store.showTaskList(props.taskListId)
  }
  isLoading.value = false
}
</script>
<template>
  <VSwitch @click="toggleTaskListVisibility" :enabled="store.taskList?.is_visible" />
</template>
